<template>
  <div class="main-bar">
    <div
      class="sub-bar"
      :style="{ width: Math.max(0, Math.min(100, percent)) + '%' }" />
  </div>
</template>

<script>
const props = {
  percent: {
    type: Number,
    required: true,
  },
};

export default {
  props,
};
</script>

<style>
.main-bar {
  background-color: var(--bar-bg);
  height: 12px;
}

.sub-bar {
  background-color: var(--sub-bg);
  height: 12px;
}
</style>
